var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrundfosLogoSymbolWhiteScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 981.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m362.25,981.19H98.83c185.71-185.85,367.37-367.62,367.37-367.62,0,0,22.22,13.48,69.93,60.66,48.38,47.84,62.68,70.18,62.68,70.18l-236.57,236.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m240.81,695.7C101.34,525.8,62.49,451.71,27.05,363.48c-22.61-56.24-50.64-166.3,7.19-224.12,51.11-51.07,151.77-33.43,253.19,12.02,116.19,52,250.26,146.92,376.28,264.82L1080,0v262.89l-380.78,381.11s-41.3-43.05-62.47-63.9C413.08,360.04,205.54,253.31,153.81,304.17c-69.24,68.13,144.3,315.93,151.72,326.93l-64.72,64.59Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1080,981.19h-148.23s-17.15-48.88-69.29-130.47c-51.42-80.42-98.32-126.28-98.32-126.28l99.91-99.84c40.35,48.35,83.21,104.86,122.72,168.15,36.67,58.7,70.74,121.71,93.22,188.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrundfosLogoSymbolWhiteScreen);
export default __webpack_public_path__ + "static/media/Grundfos_Logo-Symbol_White_SCREEN.0b10f2fbee14ec1450404111ebc62edd.svg";
export { ForwardRef as ReactComponent };